class BeltMainProduct {
  constructor(section) {
    this.section = section;
    this.current = {
      id: String(section.dataset.currentVariantId || ''),
      title: section.dataset.currentProductTitle || '',
      image: section.dataset.currentProductImage || '',
      price: Number(section.dataset.currentProductPrice || 0),
      available: section.dataset.currentProductAvailable === 'true'
    };
    this.params = new URLSearchParams(window.location.search);
    this.tier = 1;
    this.catalog = new Map();
    const jsonNode = document.querySelector(`[data-colorway-products-json="${section.dataset.sectionId}"]`);
    try {
      JSON.parse(jsonNode?.textContent || '[]').forEach((product) => {
        const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
        if (!variant) return;
        this.catalog.set(String(variant.id), {
          id: String(variant.id),
          productId: String(product.id),
          title: product.title,
          image: product.featured_image || product.images?.[0] || '',
          images: product.images || [],
          description: product.description || '',
          compareAtPrice: Number(variant.compare_at_price || 0),
          price: Number(variant.price || product.price || 0),
          available: Boolean(variant.available),
          url: product.url || ''
        });
      });
    } catch (error) {
      console.error('Unable to parse belt colorway products.', error);
    }
    section.querySelectorAll('[data-colorway]').forEach((swatch) => {
      const id = String(swatch.dataset.variantId);
      const existing = this.catalog.get(id) || {};
      this.catalog.set(id, {
        ...existing,
        id: String(swatch.dataset.variantId),
        title: existing.title || swatch.dataset.productTitle,
        image: existing.image || swatch.dataset.productImage,
        images: existing.images || [swatch.dataset.productImage],
        price: existing.price || Number(swatch.dataset.productPrice || 0),
        available: typeof existing.available === 'boolean' ? existing.available : swatch.dataset.productAvailable === 'true',
        url: swatch.dataset.productUrl
      });
    });
    this.current = this.catalog.get(this.current.id) || this.current;
    this.selectionIds = [this.current.id];
    this.initGallery();
    this.initBundle();
  }

  initGallery() {
    const panels = [...this.section.querySelectorAll('.belt-product__media-panel')];
    const thumbs = [...this.section.querySelectorAll('[data-media-target]')];
    thumbs.forEach((thumb) => thumb.onclick = () => {
      if (thumb.classList.contains('belt-product__thumb--video') && window.matchMedia('(max-width: 749px)').matches) {
        if (thumb.classList.contains('is-playing')) return;
        const sourceVideo = panels.find((panel) => panel.id === thumb.dataset.mediaTarget)?.querySelector('video');
        if (!sourceVideo) return;
        const mobileVideo = sourceVideo.cloneNode(true);
        mobileVideo.removeAttribute('id');
        mobileVideo.controls = true;
        mobileVideo.preload = 'auto';
        mobileVideo.className = 'belt-product__mobile-video';
        thumb.classList.add('is-playing');
        thumb.replaceChildren(mobileVideo);
        mobileVideo.play().catch(() => {});
        return;
      }
      panels.forEach((panel) => {
        const active = panel.id === thumb.dataset.mediaTarget;
        panel.hidden = !active;
        if (!active) panel.querySelector('video')?.pause();
      });
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
    });
  }

  initBundle() {
    this.tierButtons = [...this.section.querySelectorAll('[data-bundle-tier]')];
    this.bundleHint = this.section.querySelector('[data-bundle-hint]');
    this.bundleHintText = this.section.querySelector('[data-bundle-hint-text]');
    this.selection = this.section.querySelector('[data-bundle-selection]');
    this.addButton = this.section.querySelector('[data-add-bundle]');
    this.buyButton = this.section.querySelector('[data-buy-bundle]');
    this.addButtonLabel = this.section.querySelector('[data-add-bundle-label]');
    this.error = this.section.querySelector('[data-bundle-error]');
    this.quantity = this.section.querySelector('[data-quantity]');
    this.shippingStatus = this.section.querySelector('[data-shipping-status]');

    this.tierButtons.forEach((button) => button.addEventListener('click', () => {
      this.setTier(Number(button.dataset.bundleTier));
    }));

    this.section.querySelectorAll('[data-colorway]').forEach((swatch) => swatch.addEventListener('click', (event) => {
      event.preventDefault();
      const nextId = String(swatch.dataset.variantId);
      const nextProduct = this.catalog.get(nextId);
      if (!nextProduct) return;
      this.current = nextProduct;
      if (this.tier === 1) {
        this.selectionIds = [nextId];
      } else if (!this.selectionIds.includes(nextId)) {
        if (this.selectionIds.length < this.tier) this.selectionIds.push(nextId);
        else this.selectionIds = [...this.selectionIds.slice(0, this.tier - 1), nextId];
      }
      this.updateProduct(nextProduct);
      this.syncUrl(false, true);
      this.renderBundle();
    }));

    this.selection?.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-remove-selection]');
      if (!remove) return;
      this.removeSelection(Number(remove.dataset.removeSelection));
    });

    this.section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      this.setTier(Number(this.quantity.value || 1) - 1);
    });
    this.section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      this.setTier(Number(this.quantity.value || 1) + 1);
    });
    this.quantity?.addEventListener('change', () => {
      this.setTier(Number(this.quantity.value || 1));
    });
    this.addButton?.addEventListener('click', () => this.addBundle(false));
    this.buyButton?.addEventListener('click', () => this.addBundle(true));
    if (this.quantity) this.quantity.value = this.tier;
    this.renderBundle();
  }

  setTier(value) {
    this.tier = Math.min(3, Math.max(1, Number(value) || 1));
    if (this.quantity) this.quantity.value = this.tier;
    if (this.tier === 1) this.selectionIds = [this.current.id];
    else this.selectionIds = this.selectionIds.slice(0, this.tier);
    this.syncUrl(false);
    this.renderBundle();
  }

  updateProduct(product) {
    this.section.dataset.currentVariantId = product.id;
    this.section.dataset.currentProductTitle = product.title;
    this.section.dataset.currentProductImage = product.image;
    this.section.dataset.currentProductPrice = product.price;
    this.section.dataset.currentProductAvailable = String(product.available);
    this.section.querySelector('[data-product-title]').textContent = product.title;
    this.section.querySelector('[data-product-breadcrumb]').textContent = product.title;
    this.section.querySelector('[data-colorway-title]').textContent = product.title;
    const priceNode = this.section.querySelector('[data-product-price]');
    if (priceNode) priceNode.innerHTML = `<span>${this.formatMoney(product.price)}</span>${product.compareAtPrice > product.price ? `<s>${this.formatMoney(product.compareAtPrice)}</s>` : ''}`;
    const description = this.section.querySelector('[data-product-description]');
    if (description?.dataset.useProductDescription === 'true') description.innerHTML = product.description;
    this.section.querySelectorAll('[data-colorway]').forEach((swatch) => swatch.classList.toggle('is-active', String(swatch.dataset.variantId) === product.id));
    this.renderGallery(product);
  }

  renderGallery(product) {
    const stage = this.section.querySelector('[data-belt-gallery-stage]');
    const thumbs = this.section.querySelector('.belt-product__thumbs');
    if (!stage || !thumbs) return;
    stage.querySelectorAll('.belt-product__media-panel:not([id$="-video"])').forEach((panel) => panel.remove());
    thumbs.querySelectorAll('.belt-product__thumb:not(.belt-product__thumb--video)').forEach((thumb) => thumb.remove());
    const badge = stage.querySelector('.belt-product__media-badge');
    const images = product.images?.length ? product.images : [product.image];
    images.filter(Boolean).forEach((image, index) => {
      const panelId = `BeltMedia-${this.section.dataset.sectionId}-dynamic-${index}`;
      const panel = document.createElement('div');
      panel.id = panelId;
      panel.className = 'belt-product__media-panel';
      panel.hidden = index !== 0;
      panel.innerHTML = `<img src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(product.title)}" class="belt-product__main-image" loading="${index === 0 ? 'eager' : 'lazy'}">`;
      stage.appendChild(panel);
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = `belt-product__thumb${index === 0 ? ' is-active' : ''}`;
      thumb.dataset.mediaTarget = panelId;
      thumb.setAttribute('aria-label', `View ${product.title}`);
      thumb.innerHTML = `<img src="${this.escapeAttribute(image)}" alt="" class="belt-product__thumb-image" loading="lazy">`;
      thumbs.appendChild(thumb);
    });
    if (badge) stage.prepend(badge);
    this.initGallery();
  }

  removeSelection(index) {
    this.selectionIds.splice(index, 1);
    if (this.selectionIds.length && !this.selectionIds.includes(this.current.id)) {
      this.current = this.catalog.get(this.selectionIds[0]) || this.current;
      this.updateProduct(this.current);
    }
    this.syncUrl(false, true);
    this.renderBundle();
  }

  selectedProducts() {
    return this.selectionIds.slice(0, this.tier).map((id) => this.catalog.get(String(id))).filter(Boolean);
  }

  renderBundle() {
    this.tierButtons.forEach((button) => button.classList.toggle('is-active', Number(button.dataset.bundleTier) === this.tier));
    const products = this.selectedProducts();
    const missing = Math.max(0, this.tier - products.length);
    if (this.bundleHint) {
      this.bundleHint.hidden = this.tier === 1 || missing === 0;
      if (this.bundleHintText) this.bundleHintText.textContent = `Pick ${missing} more belt${missing === 1 ? '' : 's'}: tap a colorway swatch below to add it`;
    }
    if (this.selection) {
      this.selection.hidden = this.tier === 1;
      this.selection.innerHTML = products.map((item, index) => `<div class="belt-product__selected-item${item.available ? '' : ' is-sold-out'}"><b>${index + 1}</b><img src="${this.escapeAttribute(item.image)}" alt=""><span>${this.escape(item.title)}${item.available ? '' : ' — Sold out'}</span><em>${this.formatMoney(item.price)}</em>${this.tier > 1 ? `<button type="button" data-remove-selection="${index}" aria-label="Remove ${this.escapeAttribute(item.title)}">×</button>` : ''}</div>`).join('') + Array.from({ length: missing }, (_, index) => `<div class="belt-product__selection-empty"><b>${products.length + index + 1}</b><span>Tap a colorway below to fill slot ${products.length + index + 1}</span></div>`).join('');
    }
    const tierButton = this.tierButtons.find((button) => Number(button.dataset.bundleTier) === this.tier);
    const discount = Number(tierButton?.dataset.discount || 0);
    const subtotal = products.reduce((total, item) => total + item.price, 0);
    const total = Math.round(subtotal * (100 - discount) / 100);
    const soldOut = products.some((item) => !item.available);
    const incomplete = missing > 0;
    if (this.addButton) {
      this.addButton.disabled = soldOut || incomplete;
      if (this.addButtonLabel) this.addButtonLabel.textContent = incomplete ? `Pick ${missing} more belt${missing === 1 ? '' : 's'} below` : soldOut ? 'A selected belt is sold out' : `Add to cart · ${this.formatMoney(total)}`;
    }
    if (this.buyButton) this.buyButton.disabled = soldOut || incomplete;
    this.updateShipping(total);
  }

  updateShipping(total) {
    if (!this.shippingStatus) return;
    const threshold = Math.max(0, Number(this.shippingStatus.dataset.freeShippingThreshold || 0));
    const remaining = Math.max(0, threshold - total);
    const unlocked = threshold === 0 || remaining === 0;
    const message = this.shippingStatus.querySelector('[data-shipping-message]');
    const progress = this.shippingStatus.querySelector('[data-shipping-progress]');
    const progressFill = progress?.querySelector('i');
    this.shippingStatus.classList.toggle('is-unlocked', unlocked);
    if (message) message.innerHTML = unlocked
      ? `You’ve unlocked <b>free shipping</b>`
      : `You’re <b>${this.formatMoney(remaining)}</b> from free shipping`;
    if (progress) progress.hidden = unlocked;
    if (progressFill) progressFill.style.width = `${threshold > 0 ? Math.min(100, total / threshold * 100) : 100}%`;

    const businessDays = Math.max(0, Number(this.shippingStatus.dataset.businessDays || 0));
    const windowDays = Math.max(0, Number(this.shippingStatus.dataset.deliveryWindow || 0));
    const shippingHours = Math.max(0, Number(this.shippingStatus.dataset.shippingHours || 0));
    const arrivalStart = this.addBusinessDays(new Date(), businessDays);
    const arrivalEnd = this.addBusinessDays(arrivalStart, windowDays);
    const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' });
    const deliveryMessage = this.shippingStatus.querySelector('[data-delivery-message]');
    if (deliveryMessage) deliveryMessage.innerHTML = `Ships <b>within ${shippingHours} hours</b>. Estimated arrival <b>${dateFormat.format(arrivalStart)}${windowDays > 0 ? ` to ${dateFormat.format(arrivalEnd)}` : ''}</b>.`;
  }

  addBusinessDays(date, days) {
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }

  async addBundle(checkout) {
    const products = this.selectedProducts();
    if (products.length !== this.tier || products.some((item) => !item.available)) return;
    const tierButton = this.tierButtons.find((button) => Number(button.dataset.bundleTier) === this.tier);
    const discount = Number(tierButton?.dataset.discount || 0);
    const items = products.map((item) => ({
      id: Number(item.id),
      quantity: 1,
      properties: this.tier > 1 ? { '_Bundle tier': `${this.tier} belts`, '_Bundle discount': `${discount}%` } : {}
    }));
    if (this.error) {
      this.error.textContent = '';
      this.error.hidden = true;
    }
    this.setLoading(true, checkout ? this.buyButton : this.addButton);
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const requestBody = { items };

      if (!checkout && cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        requestBody.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        requestBody.sections_url = window.location.pathname;
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(this.addButton);
        }
      }

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(requestBody)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this bundle.');
      const discountCode = tierButton?.dataset.discountCode?.trim();

      if (checkout) {
        const destination = '/checkout';
        window.location.assign(discountCode ? `/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(destination)}` : destination);
        return;
      }

      if (discountCode) {
        await fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(window.location.pathname)}`, {
          credentials: 'same-origin'
        });
      }

      if (cartDrawer && result.sections && typeof cartDrawer.renderContents === 'function') {
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(result);
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (error) {
      if (this.error) {
        this.error.textContent = error.message;
        this.error.hidden = false;
      }
    } finally {
      this.setLoading(false);
      this.renderBundle();
    }
  }

  setLoading(loading, activeButton = null) {
    [this.addButton, this.buyButton].forEach((button) => {
      if (!button) return;
      button.disabled = loading;
      button.classList.toggle('is-loading', loading && button === activeButton);
      if (loading && button === activeButton) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
  }

  syncUrl(reload, useProductPath = false) {
    const url = new URL(useProductPath && this.current.url ? this.current.url : window.location.href, window.location.origin);
    url.searchParams.set('view', 'belt');
    url.searchParams.delete('tier');
    url.searchParams.delete('belt_bundle');
    if (reload) window.location.assign(url.toString());
    else window.history.replaceState({}, '', url.toString());
  }

  formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.section.dataset.moneyFormat);
    const format = this.section.dataset.moneyFormat || '${{amount}}';
    const token = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    let value;
    if (token === 'amount_no_decimals') {
      value = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(cents / 100);
    } else if (token === 'amount_with_comma_separator') {
      value = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    } else if (token === 'amount_no_decimals_with_comma_separator') {
      value = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(cents / 100);
    } else {
      value = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  escape(value) {
    const node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  escapeAttribute(value) {
    return this.escape(value).replace(/`/g, '&#96;');
  }
}

const initBeltMainProducts = (scope = document) => scope.querySelectorAll('.belt-product').forEach((section) => {
  if (!section.beltMainProduct) section.beltMainProduct = new BeltMainProduct(section);
});

document.addEventListener('DOMContentLoaded', () => initBeltMainProducts());
document.addEventListener('shopify:section:load', (event) => initBeltMainProducts(event.target));
